import { createAction } from 'redux-actions';

export const GET_TOPICS_REQUEST = createAction('GET_TOPICS_REQUEST');
export const GET_TOPICS_FAILURE = createAction('GET_TOPICS_FAILURE');
export const GET_TOPICS_SUCCESS = createAction('GET_TOPICS_SUCCESS');

export const GET_PROFILE_STATISTICS = createAction('GET_PROFILE_STATISTICS');
